
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MimesysTranslationsService {
  private translations: any = {};
  private currentLang = new BehaviorSubject<string>('en');

  constructor(private http: HttpClient) {}

  loadLanguage(lang: string): Observable<any> {
    const path = `assets/i18n/mimesys/${lang}.json`; // Make sure your JSONs are placed in assets/i18n/
    return this.http.get(path).pipe(
      map((data: any) => {
        this.translations = data;
        this.currentLang.next(lang);
        return data;
      })
    );
  }

  translate(key: string): string {
    const keys = key.split('.');
    let value = this.translations;
    for (const k of keys) {
      if (value && k in value) {
        value = value[k];
      } else {
        return key; // Fallback: return key if translation not found
      }
    }
    return value;
  }

  getCurrentLang(): Observable<string> {
    return this.currentLang.asObservable();
  }
}
